import { defineMessages } from 'react-intl';

export default defineMessages({
  orderSearchError: {
    id: 'view.card.client.orderSearchError',
    defaultMessage: 'An error has occurred',
  },
  orderReferenceLabel: {
    id: 'view.card.client.orderReferenceLabel',
    defaultMessage: 'Order Reference Label',
  },
  orderReferenceHelperLabel: {
    id: 'view.card.client.orderReferenceHelperLabel',
    defaultMessage: 'help',
  },
  orderReferenceHelperTitle: {
    id: 'view.MyAccountLoginPage.onlyWithOrderReference.helper.title',
    defaultMessage: 'Where can I find my invoice number?',
  },
  purchaseDateLabel: {
    id: 'view.MyAccountLoginPage.purchaseDateLoginEnable.purchaseDateLabel',
    defaultMessage: 'Purchase date',
  },
  purchaseDateHelperLabel: {
    id: 'view.MyAccountLoginPage.purchaseDateLoginEnable.purchaseDateHelperLabel',
    defaultMessage: 'help',
  },
});
